<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <table class="table table-foursight table-striped table-hover table-sm">
        <thead>
          <tr>
            <th>{{$t('QUESTION')}}</th>
            <th>{{$t('ANSWER')}}</th>
            <th>{{$t('ISCORRECT')}}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in quizPages">
            <tr class=" table-ellipsis">
              <td>{{item.question}}</td>
              <td>{{item.answer}}</td>
              <td>
                <b-form-checkbox plain id="checkbox1" v-model="item.isCorrect" value="1"></b-form-checkbox>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
export default
{
  name: 'FormPreview',
  props: ['quizPages'],
  data: function()
  {
    return {

    }
  },
  created()
  {
    var me = this;
  },
  methods:
  {

  },
  computed:
  {

  }
}
</script>
